export default "__VITE_ASSET__CSCsVLez__"